<template>
  <div id="device-info" class="scroll-vertical">
    <content-nav-bar>
      <a
        @click="refresh()"
        class="level-item">
        <svgicon name="refresh" height="25" width="25"></svgicon>
      </a>
      <p class="level-item is-size-4">Device Information</p>
    </content-nav-bar>
    <detail-item
      name="Host Name"
      imgName="name">
      {{ asset.hostName }}
    </detail-item>
    <detail-item
      name="Serial"
      imgName="serial">
      {{ asset.serial }}
    </detail-item>
    <detail-item
      name="Device ID"
      imgName="uuid">
      {{ asset.uuid }}
    </detail-item>
    <detail-item
      name="OS"
      imgName="apple">
      {{ asset.osString }}
    </detail-item>

    <detail-item
      name="Model"
      imgName="cpu">
      {{ asset.modelName }}
    </detail-item>

    <detail-item
      name="Architecture"
      imgName="arch">
      {{ asset.arch }}
    </detail-item>

    <detail-item
      name="Kernel"
      imgName="kernel">
      {{ asset.kernelVersion }}
    </detail-item>

    <detail-item
      name="Memory"
      imgName="memory">
      {{ asset.memorySize | bytesToSize }}
    </detail-item>

    <detail-item
      name="Last Connected"
      imgName="cal">
      {{ asset.checkin | formatEpochDate(gmt) }}
    </detail-item>

    <detail-item
      name="First Connected"
      imgName="cal">
      {{ asset.created | formatEpochDate(gmt) }}
    </detail-item>

    <detail-item
      name="Latitude"
      imgName="latitude">
      {{ asset.latitude }}
    </detail-item>

    <detail-item
      name="Longitude"
      imgName="longitude">
      {{ asset.longitude }}
    </detail-item>

    <detail-item
      name="Certificate ID"
      imgName="cert">
      {{ asset.certid }}
    </detail-item>

    <detail-item
      name="GamePlan Version"
      imgName="circle">
      {{ asset.version }}
    </detail-item>

    <detail-item
      name="Profile Hash"
      imgName="profile">
      {{ asset.configHash }}
    </detail-item>
  </div>
</template>

<script>
import gmt from '@/mixins/gmt';
import DetailItem from '@/components/DetailItem.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';

export default {
  name: 'AssetDetails',
  mixins: [gmt],
  components: { ContentNavBar, DetailItem },
  props: {
    asset: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async refresh() {
      await this.$store.dispatch('primary/getAsset', {
        uuid: this.$route.params.id,
      });
    },
  },
};
</script>

<style lang="scss" scoped>

#device-info {
  flex: 1;
}

.header {
  background: $sidebar-active;
  border-top: 1px solid $font-color;
  border-bottom: 1px solid $font-color;
  padding-left: $content-padding;
  padding-right: $content-padding;
  height: $navbar-height;
  margin-bottom: 0;
}

td.img {
  width: 30px;
  img {
    height: 30px;
  }
}

td.value {
  text-align: right;
}

</style>
